<template>
  <div class="page">
    <klfs-header tab="brand"></klfs-header>

    <div class="page-wrapper">

      <div class="section-block index-bg-img">
        <img src="../../assets/about/about-banner.png" alt="">
      </div>

      <div class="section-block section-block-join" id="ppjs">
        <div class="block-empty"></div>
        <div class="section-join-wrap">
          <div class="section-join-block flex">
            <div class="join-left">
              <div class="join-title">企业介绍</div>
              <div class="about-text-content">
                <p>快乐番薯起源于2008年的福建厦门，是以番薯为主题的时尚休闲空间。快乐番薯坚持“现制茶饮+休闲小吃”的双品类策略，实现双线营收，主要布局2-5线下沉市场，目前在大陆地区拥有约2000家门店，遍布全国28个省区、223个城市。</p>
                <p>2026年，位于福建省厦门海沧区的快乐番薯智能产业园通过竣工验收，正式投产。产业园总建筑面积 123221.194 ㎡，用地面积 43659.683 ㎡，是快乐番薯的茶饮全产业链研发和生产中心，可为上万家门店提供产品和物流服务。</p>
              </div>
            </div>
            <div class="join-right flex-1">
              <img class="image" src="../../assets/about/about-fs.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="section-block section-progress" id="pplc">
        <div class="section-progress-wrap">
          <h1 class="section-title">品牌历程</h1>
          <div class="brand-progress-content">
            <div class="brand-progress-view flex flex-align-bottom flex-just-center brand-progress-top">
              <div class="brand-progress-item">
                <p class="brand-progress-text">在福建拥有10家门店，开始了连锁化初体验。</p>
                <div class="brand-year">2009</div>
              </div>
              <div class="brand-progress-item">
                <p class="brand-progress-text">经过6年快速拓展，全国门店数量突破300家，为提升管理服务水平，成立股份有限公司，并投资自建供应链，开始了企业化经营管理之路。</p>
                <div class="brand-year">2015</div>
              </div>
              <div class="brand-progress-item">
                <p class="brand-progress-text">顺应行业发展趋势，在产品、门店形象、数字化、培训等方面进行全面升级，提升品牌力；同时变革内部组织及升级管理服务，引入更多行业优秀人才，打造更具竞争力的连锁管理新模型。</p>
                <div class="brand-year">2021</div>
              </div>
              <div class="brand-progress-item">
                <p class="brand-progress-text">快乐番薯食品智能产业园全面封顶，标志着快乐番薯进入供应链4.0时代。</p>
                <div class="brand-year">2025</div>
              </div>
            </div>
            <div class="brand-progress-line"></div>
            <div class="brand-progress-view flex flex-just-center brand-progress-bottom">
              <div class="brand-progress-item">
                <div class="brand-year">2008</div>
                <p class="brand-progress-text">快乐番薯首家门店创立于厦门。</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-year">2014</div>
                <p class="brand-progress-text">子公司厦门天辅星食品有限公司（全资子公司）在厦门成立。</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-year">2018</div>
                <p class="brand-progress-text">乘市场东风，快乐番薯品牌门店规模破 1000 家，7 月成为在国内新三板挂牌的茶饮连锁品牌。
                  股票代码：872940</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-year">2024</div>
                <p class="brand-progress-text">出海元年，顺利开拓香港市场和老挝、印尼等海外市场，开启全球拓展之路，获”ABEC2024 亚洲最具投资价值品牌 TOP100“及”AAA(全国级)知名商标“。快乐番薯智能产业园正式启动建设。</p>
              </div>
              <div class="brand-progress-item">
                <div class="brand-year">2026</div>
                <p class="brand-progress-text">快乐番薯智能产业园正式投产，可为上万家门店提供产品和物流服务。<br>艺人夏之光成为快乐番薯品牌代言人。</p>
              </div>
            </div>
          </div>

          <div class="brand-progress-content-m">
            <div class="brand-progress-item">
              <div class="brand-year">2008</div>
              <p class="brand-progress-text">快乐番薯首家门店创立于厦门。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2009</div>
              <p class="brand-progress-text">在福建拥有10家门店，开始了连锁化初体验。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2014</div>
              <p class="brand-progress-text">子公司厦门天辅星食品有限公司（全资子公司）在厦门成立。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2015</div>
              <p class="brand-progress-text">经过6年快速拓展，全国门店数量突破300家，为提升管理服务水平，成立股份有限公司，并投资自建供应链，开始了企业化经营管理之路。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2018</div>
              <p class="brand-progress-text">乘市场东风，快乐番薯品牌门店规模破 1000 家，7 月成为在国内新三板挂牌的茶饮连锁品牌。
                股票代码：872940</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2021</div>
              <p class="brand-progress-text">顺应行业发展趋势，在产品、门店形象、数字化、培训等方面进行全面升级，提升品牌力；同时变革内部组织及升级管理服务，引入更多行业优秀人才，打造更具竞争力的连锁管理新模型。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2024</div>
              <p class="brand-progress-text">出海元年，顺利开拓香港市场和老挝、印尼等海外市场，开启全球拓展之路，获”ABEC2024 亚洲最具投资价值品牌 TOP100“及”AAA(全国级)知名商标“。快乐番薯智能产业园正式启动建设。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2025</div>
              <p class="brand-progress-text">快乐番薯食品智能产业园全面封顶，标志着快乐番薯进入供应链4.0时代。</p>
            </div>
            <div class="brand-progress-item">
              <div class="brand-year">2026</div>
              <p class="brand-progress-text">快乐番薯智能产业园正式投产，可为上万家门店提供产品和物流服务。<br>艺人夏之光成为快乐番薯品牌代言人。</p>
            </div>
          </div>

        </div>
      </div>

      <div class="section-block section-culture" id="ppwh">
        <div class="section-culture-wrap">
          <h1 class="section-title">品牌文化</h1>
          <div class="culture-content">
            <div class="culture-item">
              <span class="culture-img">
                <img src="../../assets/about/culture1.png" alt="">
              </span>
              <h3 class="culture-item-title">使命</h3>
              <p class="culture-item-text">让每位顾客都享受到物超所值的 健康饮食</p>
            </div>
            <div class="culture-item">
              <span class="culture-img">
                <img src="../../assets/about/culture2.png" alt="">
              </span>
              <h3 class="culture-item-title">愿景</h3>
              <p class="culture-item-text">成为全球以番薯为主题的 休闲饮食引领者</p>
            </div>
            <div class="culture-item">
              <span class="culture-img">
                <img src="../../assets/about/culture3.png" alt="">
              </span>
              <h3 class="culture-item-title">核心价值观</h3>
              <p class="culture-item-text">客户至上、拥抱变化、利他共赢</p>
            </div>
            <div class="culture-item">
              <span class="culture-img">
                <img src="../../assets/about/culture4.png" alt="">
              </span>
              <h3 class="culture-item-title">品牌理念</h3>
              <p class="culture-item-text">薯与你的快乐</p>
            </div>
          </div>
        </div>
      </div>

      <div class="about-world-section" id="qqbt">
        <klfs-world></klfs-world>
      </div>

    </div>

    <klfs-footer></klfs-footer>
  </div>
</template>

<script>

import KlfsHeader from "@/components/KlfsHeader.vue";
import KlfsFooter from "@/components/KlfsFooter.vue";
import KlfsWorld from "@/components/KlfsWorld.vue";
export default {
  name: 'BrandPage',
  components: {
    KlfsHeader,
    KlfsFooter,
    KlfsWorld
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.index-bg-img img {
  display: block;
  width: 100%;
}

.section-block-join {
  margin-bottom: 110px;
  margin-top: -200px;
  padding: 0 30px;
}
.section-join-wrap {
  max-width: 1500px;
  padding: 0 20px;
  margin: 0 auto 0;
  background-color: #fff;
  box-shadow: 2px 2px 6px rgba(141, 48, 2, 0.5);
  position: relative;
  z-index: 1;
  border-radius: 25px;
}
.section-join-block {
  padding: 60px;

}
.join-left {
  width: 58%;
  margin-right: 60px;
}
.join-title {
  font-size: 50px;
  font-weight: bold;
  color: var(--p);
  margin-bottom: 50px;
}
.about-text-content {
  padding-right: 50px;
}
.about-text-content p {
  font-size: 18px;
  margin-bottom: 30px;
}

.section-progress {
  position: relative;
  background-color: #f8f8f8;
}
.section-progress:after {
  content: ' ';
  display: block;
  position: absolute;
  top: 28px;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("../../assets/about/funso.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 90%;
  z-index: 0;
}
.section-progress-wrap {
  min-width: 1200px;
  max-width: 1420px;
  padding: 0 20px 40px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.section-title {
  font-size: 50px;
  color: var(--p);
  text-align: center;
  padding: 100px 0 30px;
}

.brand-progress-content {
  padding-top: 40px;
}
.brand-progress-line {
  height: 4px;
  background: linear-gradient(90deg, rgba(8, 209, 163, 0) 0%, #FF681E 50%, #FF681E 50%, rgba(255, 104, 30, 0) 100%);
}
.brand-progress-item {
  width: 180px;
  margin: 0 30px;
}
.brand-progress-text {
  font-size: 12px;
  padding-left: 30px;
  margin-bottom: 14px;
}
.brand-year {
  height: 108px;
  font-size: 20px;
  font-weight: bold;
  color: var(--p);
  line-height: 1;
  position: relative;
  padding-left: 30px;
  margin-bottom: -9px;
}
.brand-year:before {
  content: ' ';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  background-image: url("../../assets/about/progress-top.png");
  background-repeat: no-repeat;
  background-position: top left;
}
.brand-year:after {
  content: ' ';
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid var(--p);
  position: absolute;
  bottom: 0;
  left: 4px;
  background-color: #f8f8f8;
}
.brand-progress-bottom .brand-progress-text {
  margin-bottom: unset;
  margin-top: 14px;
}
.brand-progress-bottom .brand-year {
  display: flex;
  align-items: flex-end;
  margin-top: -9px;
  margin-bottom: unset;
}
.brand-progress-bottom .brand-year:before{
  background-image: url("../../assets/about/progress-bottom.png");
  background-position: bottom left;
}
.brand-progress-bottom .brand-year:after {
  bottom: unset;
  top: 0;
}

.section-culture-wrap {
  max-width: 1420px;
  padding: 0 20px 100px;
  margin: 0 auto;
  position: relative;
}
.culture-content {
  white-space: nowrap;
  padding: 0 20px;
}
.culture-item {
  width: 28%;
  height: 240px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  background-color: #f8f8f8;
  padding: 30px 36px;
  border-radius: 100% / 100%;
  margin: 0 -20px;
}
.culture-item-title {
  font-size: 30px;
  color: var(--p);
  margin-top: 4px;
  margin-bottom: 36px;
}
.culture-item-text {
  width: 70%;
  white-space: pre-wrap;
  text-align: center;
  margin: 0 auto;
}

.about-world-section {
  padding-top: 60px;
  margin-bottom: -50px;
}

.brand-progress-content-m {
  display: none;
}
.block-empty {
  height: 120px;
}

@media screen and (max-width: 768px) {
  .block-empty {
    height: 70px;
  }
  .section-title {
    font-size: 22px;
    padding: 20px 0;
  }

  .section-block-join {
    padding: 0 20px;
    margin-bottom: 30px;
    margin-top: -40px;
  }

  .join-title {
    font-size: 22px;
    margin-bottom: 20px;
  }

  .section-join-block {
    flex-direction: column;
    padding: 20px 0;
  }

  .join-left {
    width: 100%;
  }

  .about-text-content {
    padding: 0;
  }

  .about-text-content p {
    font-size: 14px;
    margin-bottom: 16px;
  }

  .section-progress-wrap {
    min-width: unset;
    padding: 60px 15px 60px;
  }

  .brand-progress-content-m {
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 20px;
    padding-top: 20px;
  }
  .brand-progress-content-m:after {
    display: block;
    content: ' ';
    width: 4px;
    position: absolute;
    left: 80px;
    top: -20px;
    bottom: -20px;
    background: linear-gradient(180deg, rgba(8, 209, 163, 0) 0%, #FF681E 50%, #FF681E 50%, rgba(255, 104, 30, 0) 100%);
    z-index: 0;
  }
  .brand-progress-content {
    display: none;
  }
  .section-progress:after {
    display: none;
  }
  .brand-progress-view {
    flex: 1;
    flex-direction: column;
  }
  .brand-progress-item {
    display: flex;
    width: auto;
    margin: 0 20px 10px 0;
  }
  .brand-progress-text {
    padding-left: 0;
  }
  .brand-year:before {
    display: none;
  }
  .brand-year {
    font-size: 18px;
    height: auto;
    padding-left: 0;
    margin-bottom: 0;
    text-align: left;
    margin-bottom: 14px;
    margin-right: 30px;
    padding-top: 2px;
  }
  .brand-year:after {
    left: unset;
    right: -27px;
    top: 4px;
    z-index: 1;
  }
  .brand-progress-text {
    padding-left: 10px;
  }

  .section-culture-wrap {
    padding: 0 10px 30px;
  }
  .culture-content {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
  }
  .culture-item {
    width: 46%;
    height: auto;
    margin: 0;
    border-radius: 30px;
    margin: 0 2%;
    padding: 20px;
    margin-bottom: 16px;
  }
  .culture-item-title {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .culture-item-text {
    width: auto;
  }

  ::v-deep .world-content {
    padding-bottom: 80px;
  }
  .section-culture {
    padding-top: 60px;
  }
}

</style>
